var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyImgPlaceholder = function SvgHappyImgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 14 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M9.708 2.167a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25m0 2.166a.542.542 0 1 1 0-1.083.542.542 0 0 1 0 1.083M11.875 0h-9.75A1.625 1.625 0 0 0 .5 1.625v8.667a1.625 1.625 0 0 0 1.625 1.625h9.75a1.625 1.625 0 0 0 1.625-1.625V1.625A1.625 1.625 0 0 0 11.875 0m-9.75 10.833a.54.54 0 0 1-.542-.541V8.369L4.162 5.46a.3.3 0 0 1 .265 0L7.83 9.3l1.338 1.533zm10.292-.541a.54.54 0 0 1-.542.541h-1.24l-.103-.113-1.577-1.783 1.165-1.31a.3.3 0 0 1 .26 0l2.037 2.296zm0-2.005-1.224-1.386a1.34 1.34 0 0 0-1.886 0L8.224 8.12 5.23 4.734a1.34 1.34 0 0 0-1.885 0l-1.76 1.999V1.625a.54.54 0 0 1 .541-.542h9.75a.54.54 0 0 1 .542.542z"
  })));
};
export default SvgHappyImgPlaceholder;